export default __webpack_public_path__ + "feee40a33baac458f4446d5327ef51a8.mtl";